import React from "react";
import { useFormik } from "formik";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { addCareer, updateCareer } from "../../../data/ApiEndpoints";
import { useDispatch } from "react-redux";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { careerValidationSchema } from "../../../schema/website-schema";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CareerForm = ({
  initialValues,
  isEdit,
  closeModal,
  token,
  getCareerData,
}) => {
  const dispatch = useDispatch();

  // Formik setup
  const formik = useFormik({
    initialValues: initialValues || {
      title: "",
      location: "",
      description: "",
    },
    validationSchema: careerValidationSchema,
    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit ? updateCareer : addCareer;

      const payload = {
        uid: initialValues?.uid,
        job_title: values?.title,
        location: values?.location,
        job_description: values?.description,
      };

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getCareerData();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  return (
    <div className="createNewCTOModalContainer mod-width-50p careerFormModal">
      <CommonHeadingNBtns
        title={isEdit ? "Edit Job" : "Add New Job"}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Save"}
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <input
              type="text"
              name="title"
              className="input-k"
              placeholder="Job Title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.title && formik.errors.title ? (
              <div className="error-message">{formik.errors.title}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <input
              type="text"
              name="location"
              className="input-k"
              placeholder="Enter Location"
              value={formik.values.location}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.location && formik.errors.location ? (
              <div className="error-message">{formik.errors.location}</div>
            ) : null}
          </div>
        </div>
        <div className="formInputBox form__Quill">
          <label htmlFor="description" className="formInputLabel">
            Description
          </label>

          <ReactQuill
            id="description"
            className="input__Quill"
            name="description"
            placeholder="Enter Description"
            value={formik.values.description}
            onBlur={() => formik.setFieldTouched("description")}
            onChange={(content) => formik.setFieldValue("description", content)}
          />

          {formik.touched.description && formik.errors.description ? (
            <div className="error-message">{formik.errors.description}</div>
          ) : null}
        </div>
      </form>
    </div>
  );
};

export default CareerForm;
